module.exports = __webpack_public_path__ + "static/img/bg_5.b466a66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_5.jpg
// module id = bSOn
// module chunks = 1